import $ from 'jquery';
export const init = async function() {
    $(document).on('click', '.js-zoom-img', ()=>{
        Shopify.analytics.publish('zoom_click', {
            event: 'Zoom Click'
        });
        // img element inside div
        const item = $('#js-pdp-gallery-desktop .swiper-slide-active .js-zoom-img').find('img');
        // desktop - correct
        if (window.innerWidth > 1023) {
            if (item.hasClass('hover')) {
                item.removeClass('hover');
                return null;
            } else {
                item.addClass('hover');
            }
            $('#js-pdp-gallery-desktop .swiper-slide-active .js-zoom-img').on('mousemove', function(e) {
                const zoomer = e.currentTarget;
                const offsetX = e.offsetX;
                const offsetY = e.offsetY;
                const x = offsetX / zoomer.offsetWidth * 100;
                const y = offsetY / zoomer.offsetHeight * 100;
                zoomer.style.backgroundPosition = x + '% ' + y + '%';
            }).on('mouseleave', function() {
                item.removeClass('hover');
            });
        }
    });
};
